import { Link, useLocation } from 'react-router-dom';
import { useLogout } from '../../hooks';

const UserSidebar = () => {
  const { pathname } = useLocation();
  return (
    <section id="sidebar">
      <header><h3>Account</h3></header>
      <aside>
        <ul className="sidebar-navigation">
          <li className={pathname === '/admin/profile' ? 'active' : ''}>
            <Link to="/admin/profile">
              <i className="fa fa-user"/>
              <span>Profile</span>
            </Link>
          </li>
          <li className={pathname.includes('/admin/properties') ? 'active' : ''}>
            <Link to="/admin/properties">
              <i className="fa fa-home"/>
              <span>Properties</span>
            </Link>
          </li>
          <li className={pathname.includes('/admin/payment/methods') ? 'active' : ''}>
            <Link to="/admin/payment/methods">
              <i className="fa fa-dollar"/>
              <span>Payment Methods</span>
            </Link>
          </li>
          <li className={pathname.includes('/admin/users') ? 'active' : ''}>
            <Link to="/admin/users">
              <i className="fa fa-users"/>
              <span>Users</span>
            </Link>
          </li>
          <li className={pathname.includes('/admin/purchases') ? 'active' : ''}>
            <Link to="/admin/purchases">
              <i className="fa fa-shopping-cart"/>
              <span>Purchases</span>
            </Link>
          </li>
          <li>
            <Link to="#" onClick={useLogout}>
              <i className="fa fa-sign-out"/>
              <span>Logout</span>
            </Link>
          </li>
        </ul>
      </aside>
    </section>
  );
}

export default UserSidebar;